// import React, { useEffect, Suspense, useMemo } from 'react';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';

import { Notification } from '@vds/notifications';
// import { Loader } from '@vds/loaders';

// import { useExpressCheckoutHooks } from '../ExpressCheckout/@Redux/hooks';
// import { selectStateCache } from '../ExpressCheckout/@selectors';

import { getCookie } from '../../../common/Helpers/index';

import NBSHeader from './NBSHeader';
import NBSView from './NBSView';
import NBSPendingDiscount from './NBSPendingDiscount';
import NBSMonthlyBill from './NBSMonthlyBill';
import NBSFooter from './NBSFooter';
import NBSGraph from './NBSGraph';
import SkeletonNBS from './NBSSkeleton';
import { getNBSData, nbsState, getNBSError, getFeatureFlag } from '../@Redux/selectors';
import { formatCurrency } from '../NextBillsUtils';
// import RemoteLoader from '../../../../Remote/RemoteLoader';

// const NBSApp = (props) => useMemo(() => <RemoteLoader {...props} />, [props.moduleProps.unifiedNbsData]);

const MainView = (props) => {
  console.log('loading nbs....', props);
  const dispatch = useDispatch();
  const nbs = useSelector((state) => nbsState(state), shallowEqual);
  const nbsNotificationError = useSelector((state) => getNBSError(state), shallowEqual);
  // const stateCache = useSelector((state) => selectStateCache(state), shallowEqual);
  const data = useSelector((state) => getNBSData(state), shallowEqual);
  const dbrFlag = useSelector((state) => getFeatureFlag(state), shallowEqual);
  const typeOfTransaction = data?.nbsIndicators?.typeOfTransaction?.trim().toUpperCase();
  const isLoggedIn = window.vzFlags?.isLoggedIn;
  // const isUnifiedNBSEnabled = getCookie('cdlThrottleList') && getCookie('cdlThrottleList')?.includes('enableFullBlownMfeNbs');
  const isUnifiedNBSEnabled = false;
  // const expressCheckoutProps = useExpressCheckoutHooks(stateCache);
  // const { getLines } = expressCheckoutProps;
  // const unifiedNbsData = getLines?.[0]?.unifiedNbsData || '';

  // const unifiedNbsProps = useMemo(
  //   () => ({
  //     scope: 'unifiednbs',
  //     module: './unifiednbs',
  //     remote: 'unifiednbs',
  //     moduleProps: {
  //       unifiedNbsData,
  //     },
  //   }),
  //   [unifiedNbsData],
  // );

  useEffect(() => {
    if (props?.initialized && !props?.initialized?.initial) {
      // prevent multiple calls
      props.initialized.setValue(true);
      if (!nbs.nbsLoaded && !isUnifiedNBSEnabled) {
        dispatch({ type: 'NBS_GET_PAGE_DATA' });
      }
    }
  }, [props.initialized]);

  useEffect(() => {
    if (nbs?.nbsLoaded) {
      const defaultPayload = {
        name: 'next-bill-summary-modal',
        selector: `#${`id-${props.elementId}`}`,
        event: nbs?.nbsVo?.monthlyTotalsInfo
          ? `event269=${formatCurrency(nbs.nbsVo.monthlyTotalsInfo.nextMonthCharge)},event270=${formatCurrency(nbs.nbsVo.monthlyTotalsInfo.newMonthCharge)}`
          : null,
      };
      if (window?.vztag?.api?.dispatch) {
        window.vztag.api.dispatch('openView', defaultPayload);
      }
    }
  }, [nbs.nbsLoaded]);

  return (
    <div>
      {nbs?.nbsLoaded && !isUnifiedNBSEnabled && (
        <>
          <NBSHeader data={data} />
          <NBSView data={data} dbrFlag={dbrFlag} />
          {isLoggedIn && <NBSPendingDiscount data={data} />}
          <NBSMonthlyBill data={data} />
          <NBSFooter data={data} />
          {typeOfTransaction !== 'C' && typeOfTransaction !== 'Y' && <NBSGraph data={data} />}
        </>
      )}
      {/* {isUnifiedNBSEnabled && (
        <Suspense fallback={<Loader active />}>
          <NBSApp {...unifiedNbsProps} />
        </Suspense>
      )} */}
      {!isUnifiedNBSEnabled && !nbs?.nbsLoaded && !nbsNotificationError && <SkeletonNBS />}
      {!nbs?.nbsLoaded && nbsNotificationError && <Notification type="error" title={nbsNotificationError} disableFocus hideCloseButton />}
    </div>
  );
};

MainView.propTypes = {
  elementId: PropTypes.string,
  initialized: PropTypes.object,
};

export default React.memo(MainView);
